<template>
  <div>
    <gg-card>
      <gg-card-header >
        Ticket History
      </gg-card-header>
      <div v-for="(post, i) in posts" :key="`post-${i}`">
          <gg-card-text :class="post.staff ? 'reply-admin' : ''">
            <v-row>
              <v-col cols="12">
                <div class="subtitle-2">
                  <span class="font-weight-bold">
                    {{ post.fullname }}
                  </span>
                  <span class="reply-email font-weight-bold">({{ post.email }})</span>
                  <span class="d-none d-sm-inline">
                    on {{ post.dateline }}
                  </span>
                  <span v-if="post.staff" class="admin-chip mb-1 primary-color">
                    (GreenGeeks Staff)
                  </span>
                  <feedback v-if="post.staff" :post="post" />
                </div>
              </v-col>
              <v-col cols="12" class="d-flex d-sm-none pt-0">
                <div class="b-block mb-2 text-right">
                  on {{ post.dateline }}
                </div>
              </v-col>
            </v-row>
          </gg-card-text>
          <v-card-text class="post-white-space fs-15" v-html="sanitize(post.contents)" />
          <v-card-actions v-if="post.attachments.length">
            <gg-btn
              tertiary
              v-for="(attachment, index) in post.attachments"
              :key="index"
              @click="downloadAttachment(attachment.attachmentid)">
              <v-icon size="18">mdi-paperclip</v-icon>
              <span class="text-none">{{ attachment.filename }} ({{ humanFileSize(attachment.filesize) }})</span>
            </gg-btn>
          </v-card-actions>
      <hr class="mr-3 ml-3">
      </div>
    </gg-card>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'
import { humanFileSize } from '@/helpers/helpers'
import Feedback from 'Components/Support/TicketSingle/Feedback'

export default {
  name: 'Posts',
  components: { Feedback },
  props: {
    ticketid: {
      type: String,
      required: true
    },
    posts: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions(['reportError']),
    humanFileSize,
    async downloadAttachment (attachmentid) {
      try {
        const data = {
          ticketmaskid: this.ticketid,
          attachmentid
        }

        const response = await amapi.makecall('ticket_get', { ...data })
        const rawfile = atob(response.content)
        const x = new Uint8Array(rawfile.length)
        for (let i = 0; i < rawfile.length; ++i) {
          x[i] = rawfile.charCodeAt(i)
        }
        const blob = new Blob([x], { type: response.filetype })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = response.filename
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        this.reportError(e)
      }
    },
    sanitize (msg) {
      return DOMPurify.sanitize(msg, { // AM-516
        ALLOWED_TAGS: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
          'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'div',
          'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'u', 'br' ]
      }).replace(/\n\s+\n/g, '\n\n') // replace extra linebreaks
    }
  }
}
</script>

<style lang="scss" scoped>
  .reply-admin {
    .app-card {
      background: #F0FFF0;
    }
    .app-card-title {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .admin-chip {
      border-radius: 0;
      margin: 0 0 10px 0;
      color: #0ca750;
      font-weight: bold;
    }
  }

  .reply-email {
    text-transform: lowercase;
  }

  .reply-margin {
    margin-top: 30px;
  }

  .post-white-space {
    white-space: pre-line;
    line-height: 1.2rem;
  }

  .fs-15 {
    font-size: 15px;
  }
</style>
